// Acessibilidade: torna um elemento não-semântico (li/tr/div) ativável por teclado como um botão.
// Uso: <li {...teclaAtiva(() => onSelect(id))} onClick={...}> — Enter/Espaço disparam a ação.
// Para <tr> (linha de tabela), passe role=null para não conflitar com o papel "row".
export function teclaAtiva(onActivate, role = "button") {
  return {
    ...(role ? { role } : {}),
    tabIndex: 0,
    onKeyDown: (e) => {
      // Só ativa se o evento nasceu NESTE elemento — ignora keydown borbulhado de filhos
      // interativos (ex.: botões dentro de um card clicável), evitando ação dupla.
      if (e.target !== e.currentTarget) return;
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onActivate?.(); }
    },
  };
}
